import { useInfiniteQuery } from '@tanstack/react-query';
import { type z } from 'zod';

import { request } from '@/lib/http';
import { pagina, porCursor } from '@/lib/paginacao';
import { chavePendenteSchema, type statusChavePendenteSchema } from '@fiscoai/contracts';

export type StatusChave = z.infer<typeof statusChavePendenteSchema>;

export function useChavesPendentes(empresaIds: readonly string[], status: StatusChave, q: string) {
  return useInfiniteQuery({
    queryKey: ['chaves-pendentes', empresaIds, status, q],
    queryFn: ({ pageParam, signal }) =>
      request('/chaves-pendentes', {
        schema: pagina(chavePendenteSchema),
        query: { empresaIds, status, q: q || undefined, cursor: pageParam, limit: 100 },
        signal,
      }),
    ...porCursor,
  });
}
